import styled, { css } from 'styled-components';
import { breakpointsMedia } from '@nubank/nuds-web/styles/breakpoints';
import Typography from '@nubank/nuds-web/components/Typography/Typography';

export const StyledTypography = styled(Typography)`
  ${breakpointsMedia({
    lg: css`
      max-width: 33rem;
    `,
  })}
`;

StyledTypography.displayName = 'StyledTypography';
